import { useLoaderData } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { AgreementFlow } from "./UserAgreementForm";

interface UserAgreementGateProps {
	children: ReactNode;
}

/**
 * When the user has not signed the user agreement, shows the agreement document
 * on the main page and a "Sign now" button that opens the signature pad in a drawer.
 * On success, marks signed and closes the drawer so they continue their transaction flow.
 * Signed state is local only (resets on refresh/navigation away).
 */
export function UserAgreementGate({ children }: UserAgreementGateProps) {
	const location = useLoaderData({ from: "__root__" });
	const { signed } = useLoaderData({ from: "/main/deposit" });
	if (signed) {
		return children;
	}

	return <AgreementFlow locationId={location.location_id} />;
}
